<script>
import Layout from '@layouts/main'
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter } from '@utils/filter-value-to-text'
import BaseButtonDialog from '@components/BaseButtonDialog'
import { authComputed, merchantComputed } from '@state/helpers'
import formatDate from '@utils/format-date'

import pageMixin from '@src/mixins/pagination'
import { PortalTarget } from 'portal-vue'

export default {
  page: {
    title: '查看客戶資訊',
    meta: [{ name: 'description', content: 'View Member' }],
  },
  filters: { genderFilter },
  components: {
    Layout,
    BaseButtonDialog,
    PortalTarget,
    NotificationWrite: () => lazyLoadComponent(import('@components/NotificationWrite')),
    DepositOrderForm: () => lazyLoadComponent(import('@components/Orders/DepositOrderForm')),
    DepositOrderDetail: () => lazyLoadComponent(import('@components/Orders/DepositOrderDetail')),
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
    PrepaidOrderDetail: () => import('@components/Orders/PrepaidOrderDetail'),
    CombineLineNotify: () => lazyLoadComponent(import('@views/member/components/CombineLineNotify')),
  },
  mixins: [pageMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      delay: true,
      activeTabIndex: 0,
      noti: 0,
      dialogVisible: false,
      sideTabList: [
        {
          icon: 'edit',
          iconStyle: 'far',
          title: '編輯客戶資訊',
          name: 'edit',
          component: () => import('./DetailEdit'),
        },
        {
          icon: 'history',
          iconStyle: 'far',
          title: '所有訂單記錄',
          name: 'orders',
          component: () => import('./DetailOrders'),
        },
        {
          icon: 'paw',
          iconStyle: 'fal',
          title: `${this.$t('reserve.CLIENT')}列表`,
          name: 'pets',
          component: () => import('./DetailPets'),
        },
      ],
      componentData: Object.assign({}, this.defaultValue),
      depositShow: false,
      filterData: {
        order: 'desc',
      },
      tableData: [],
      tryingFetch: false,
      depositType: {
        charge: '儲值',
        paid: '抵扣',
        withdraw: '結清為現金',
        refund: '退款為儲值金',
      },
      createDepositOrderVisible: false,
      componentKey: 0,
      orderRefundShow: false,
      // 退款
      refundSubmitData: {
        date: formatDate(new Date(), 'date-dash'),
        reason: '',
        paymentMethod: '',
        point: '',
      },
      canPartialRefund: true,
      tryingRefund: false,
      tryingToGetOrder: false,
      editOrderVisible: false,
      drawerOrderData: {},
      orderComponents: {
        order: 'ReservationOrderDetail',
        prepaidOrder: 'PrepaidOrderDetail',
        depositOrder: 'DepositOrderDetail',
      },
      activeOrder: 'order',
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      orderSecondType: 'deposit'
    }
  },
  computed: {
    memberAvatar() {
      if (this.$appType() === 'ipetbooking') {
        return require(`@assets/images/member_avatar_${this.componentData.gender || 'female'}.png`)
      }
      if (this.$appType() === 'dingbeauty') {
        return require(`@assets/images/user_dbpic.svg`)
      }
    },
    ...authComputed,
    ...merchantComputed,
    /**
     * @description 當點選左邊的tab時，右邊會跳成怎樣
     */
    activeTab() {
      if(this.activeTabIndex === 3){
        return this.sideTabList[0]
      }
      return this.sideTabList[this.activeTabIndex]
    },
    pagination() {
      return this.$route.params.pagination
    },
    depositInfo() {
      return this.componentData.depositInfo
    },
    refundRules() {
      return {
        date: [
          {
            required: true,
            message: '請選擇日期',
          },
        ],
        reason: [
          {
            required: true,
            message: '請輸入退款原因',
          },
        ],
        paymentMethod: {
          required: true,
          message: '請選擇退款方式',
        },
      }
    },
    depositReduce() {
      const { bonus, point } = this.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    solutionByTotal() {
      return this.depositInfo.solution1
    },
    solutionByTime() {
      return this.depositInfo.solution2
    },
    isDepositCanRefund() {
      return this.depositInfo.solution1.canWithdrawTotal || this.depositInfo.solution2.canWithdrawTotal.point
    },
    activeOrderComponent() {
      return this.orderComponents[this.activeOrder]
    },
    mapTemplateString() {
      return {
        "姓名": this.componentData.fullName,
        "店家名稱": this.currentMerchant.name,
        "店家電話": this.currentMerchant.phoneNumber
      }
    }
  },
  watch: {
    currentPage: {
      handler: 'tryToFetchList',
      immediate: false,
    },
    activeTabIndex(ovl, nvl){
      // console.log(ovl, nvl)
    }
  },
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.delay = false
    }, 500)
  },
  methods: {
    showDeposit() {
      this.depositShow = true
      this.tryToFetchList()
      this.activeTabIndex = 3
    },
    backToList() {
      this.$router.push({
        name: 'member',
        params: { pagination: this.pagination },
      })
    },
    closeDialog() {
      this.dialogVisible = false
    },
    goChat() {
      this.$router.push({
        name: 'view-chat',
        params: { memberId: this.defaultValue.id },
      })
    },
    handleResetSearch() { },

    async tryToFetchList(type) {
      // 當篩選前不在第一頁的時候，跳回第一頁
      if (this.currentPage !== 1 && type === 'filter') {
        this.currentPage = 1
        return
      }
      this.tryingFetch = true
      const query = { ...this.filterData }

      const { items, total } = await this.$store.dispatch('deposit/fetchHistoryList', { ...query, ...this.pageQuery, member_id: this.defaultValue.id })

      this.tableData = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
        if (this.$refs.pagination) {
        }
      })
      this.tryingFetch = false
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      this.tryToFetchList()
      this.tryToFetchMember()
    },
    openCreateDeposit(type) {
      this.orderSecondType = type
      this.createDepositOrderVisible = true
    },
    openDepositRefund() {
      this.orderRefundShow = true
    },
    closeOpenRefund() {
      this.orderRefundShow = false
    },
    async tryToRefund(id) {
      try {
        await this.$refs.refundForm.validate()
        this.tryingRefund = true
        const point = this.refundSubmitData.method === 1
          ? this.depositInfo.solution1.canWithdrawTotal
          : this.depositInfo.solution2.canWithdrawTotal.point
        await this.$store.dispatch('deposit/withdraw', {
          point,
          member_id: id,
          extraInfo: this.refundSubmitData,
        })
        this.$confirm('退款已完成', '提示', {
          confirmButtonText: '關閉',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        this.tryToFetchMember()
        this.tryToFetchList()
        this.orderRefundShow = false
      } catch (error) {
        // console.log('TCL: tryToCreateOrder -> error', error)
      } finally {
        // this.tryingStore = false
      }
    },
    onCellClick({ type = '', order_uuid, order_id, sizeTitle = '' }) {
      if (!type) return
      this.tryToGetOrder(type, order_uuid, order_id, sizeTitle)
    },
    async tryToGetOrder(type, order_uuid, order_id, sizeTitle) {
      try {
        this.tryingToGetOrder = true
        if (type === 'order') {
          const result = await this.$store.dispatch('order/fetchContainerList', order_uuid)
          this.$router.push({
            path: '/orders',
            query: {
              id: result['orders'][0]['id'],
              type: 'order'
            }
          });
        }
        if (type === 'prepaidOrder') {
          this.$router.push({
            path: '/orders',
            query: {
              id: order_uuid,
              type: 'prepaidOrder'
            }
          });
        }
        if (type === 'depositOrder') {
          const result = await this.$store.dispatch('order/fetchContainerList', order_uuid)
          this.$router.push({
            path: '/orders',
            query: {
              id: result['orders'][0]['id'],
              type: 'depositOrder'
            }
          });
        }

        this.activeOrder = type
        this.editOrderVisible = true
      } catch {
      } finally {
        this.tryingToGetOrder = false
      }
    },
    async onEditOrderDone() {
      this.$refs.orderFormEdit.closeDrawer()
      this.tryToFetchList()
      this.tryToFetchMember()
    },
    async tryToFetchMember() {
      const memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId: this.$route.params.memberId })
      this.componentData = memberInfo
    },
    closeDeposit() {
      this.depositShow = false
    },
    onUpdate() {
      this.tryToFetchMember()
    }
  },
}
</script>

<template>
  <Layout>
    <div v-if="delay" v-loading="delay" style="height: 100vh"></div>
    <template v-else>
      <div :class="$style.wrapper">
        <div :class="$style.sidebar">
          <div class="sidebar__left">
            <div :class="$style.header">
              <el-button class="is-round isStyleBase" @click="backToList">
                <BaseIcon name="arrow-left" />
                返回
              </el-button>
              <div :class="$style.intro">
                <el-avatar :src="memberAvatar" :size="100"></el-avatar>
                <div v-if="$hasMemberLevel()" class="my-2">
                  <el-tag class="isStyleTag">
                    {{ componentData.level.title }}
                  </el-tag>
                </div>
                <h3>{{ componentData.fullName }} {{ componentData.gender | genderFilter }}</h3>
                <ul class="Jost infoList">
                  <li>{{ `${componentData.phoneCode} ${componentData.phoneNumber}` }}</li>
                  <li>{{ componentData.email }}</li>
                </ul>
              </div>
            </div>
            <template v-if="$hasDeposit()">

              <div :class="$style.overview" style="border-bottom: 0">
                <div :class="$style['overview__item']">
                  <div :class="$style['overview__value']" class="Jost">{{ depositReduce }}</div>儲值餘額
                </div>
                <div :class="$style['overview__item']" style="border-left: 0">
                  <el-button class="is-round isStyleBase" @click="showDeposit">點數查詢/儲值</el-button>
                </div>
              </div>
            </template>

            <div :class="$style.overview">
              <div :class="$style['overview__item']">
                <div :class="$style['overview__value']" class="Jost">{{ componentData.ordersCounts +
                  componentData.prepaidCounts }}</div>有效訂單筆數
              </div>
              <div :class="$style['overview__item']">
                <div :class="$style['overview__value']" class="Jost">{{ componentData.ordersTotal }}</div>累積美容消費
              </div>
            </div>
            <div v-if="$hasHotel()" :class="$style.overview">
              <div :class="$style['overview__item']">
                <div :class="$style['overview__value']" class="Jost">{{ componentData.hotelOrdersCounts }}</div>有效住宿訂單
              </div>
              <div :class="$style['overview__item']">
                <div :class="$style['overview__value']" class="Jost">{{ componentData.hotelOrdersTotal }}</div>累積住宿消費
              </div>
            </div>
            <div @click="closeDeposit">
              <el-radio-group v-model="activeTabIndex" class="is-block" :class="$style.tabs">
                <el-radio-button :class="$style.enabled" :label="0">
                  <BaseIcon name="edit" />
                  <span>編輯客戶資訊</span>
                </el-radio-button>

                <el-radio-button :class="$style.enabled" :label="1">
                  <BaseIcon name="history" />
                  <span>所有訂單紀錄</span>
                </el-radio-button>

                <el-radio-group class="is-block" :class="$style.tabs">
                  <el-radio-button :class="$style.enabled" :label="1" disabled @click.native="dialogVisible = true">
                    <BaseIcon name="paper-plane" icon-style="fal" />
                    <span>撰寫通知</span>
                  </el-radio-button>
                  <el-radio-button v-show="false" :label="0" @click.native="dialogVisible = true"> </el-radio-button>
                </el-radio-group>

                <el-radio-group v-if="currentUserRoutes && currentUserRoutes.includes('chat')" class="is-block"
                  :class="$style.tabs">
                  <el-radio-button :class="$style.enabled" :label="1" disabled @click.native="goChat">
                    <BaseIcon name="comments" />
                    <span>對話紀錄</span>
                  </el-radio-button>
                </el-radio-group>

                <el-radio-button :class="$style.enabled" :label="2">
                  <BaseIcon name="paw" icon-style="fal" />
                  <span>{{ $t('reserve.CLIENT') }}列表/服務紀錄</span>
                </el-radio-button>

              </el-radio-group>
            </div>
          </div>
        </div>

        <div :class="$style.content">
          <template v-if="depositShow">
            <div v-loading.fullscreen.lock="tryingToGetOrder" class="isStylePageContent bg-transparent"
              element-loading-text="取得訂單資訊中...">
              <div :class="$style.btnTop" class="form-block-title">
                <BasePageHeader title="儲值金記錄" />
                <span>
                  <el-button class="is-round" type="primary" @click="openCreateDeposit('deduct')">
                    <BaseIcon name="plus" />
                    <span>立即抵扣</span>
                  </el-button>
                  <el-button class="is-round" type="primary" @click="openCreateDeposit('deposit')">
                    <BaseIcon name="plus" />
                    <span>立即儲值</span>
                  </el-button>
                  <el-button v-if="isDepositCanRefund" class="is-round" type="danger" @click="openDepositRefund">
                    <span>點數全數退款</span>
                  </el-button>
                </span>
              </div>
              <div class="bg-white">
                <div class="el-table-wrapper">
                  <el-table v-loading="tryingFetch" element-loading-text="取得儲值金記錄中" :data="tableData"
                    :class="$style['table']" row-key="id" class="isBgDark">
                    <el-table-column v-slot="{ row }" label="日期" min-width="160"> {{ row.createdAt }} <br />
                    </el-table-column>
                    <el-table-column v-slot="{ row }" label="原因" min-width="150">
                      {{ depositType[row.type] }} : {{ row.extraInfo.price_title }} <br />
                      <span v-if="['jtailsShopOrder', 'customize'].includes(row.extraInfo.type)">{{
                        row.extraInfo.display_order_id }}</span>
                      <el-button v-else type="text" style="padding-top: 0; text-decoration: underline"
                        @click="onCellClick(row.extraInfo)">{{ row.extraInfo.display_order_id }}</el-button>
                    </el-table-column>
                    <el-table-column v-slot="{ row }" label="儲值/使用" min-width="60"> <span
                        v-if="row.type === 'charge'">+</span>{{ row.total }} </el-table-column>
                    <el-table-column v-slot="{ row }" label="餘額" min-width="60"> {{ row.reduce }} 點 </el-table-column>
                  </el-table>
                </div>
                <BasePagination ref="pagination" :current-page.sync="currentPage" />
              </div>

            </div>
          </template>
          <template v-else>
            <keep-alive>
              <component :is="activeTab.component" :key="activeTab.name" :default-value.sync="componentData"
                @update="onUpdate">
              </component>
            </keep-alive>
          </template>
        </div>

        <BaseButtonDialog width="550px" :only-dialog="true" :title="'撰寫通知'" :dialog-visible.sync="dialogVisible"
          :destroy="true" floating>
          <NotificationWrite :selected-member-ids="[defaultValue.id]" :source-name="'member'"
            :source-member="defaultValue" :map-template-string="mapTemplateString" @close="closeDialog" />
        </BaseButtonDialog>

        <!-- 新增儲值金訂單 -->
        <el-drawer ref="depositOrderForm" class="only-close" :class="{ 'appStyle': appStyle }"
          :visible.sync="createDepositOrderVisible" :append-to-body="true" :size="$root.isSmallDevice ? '100%' : '90%'"
          destroy-on-close :modal-append-to-body="false" :wrapper-closable="false" custom-class="order-drawer">
          <DepositOrderForm order-type="deposit" :order-second-type="orderSecondType" :order-member-id="defaultValue.id"
            @store="onCreateDepositOrderDone" />
        </el-drawer>
        <!-- 編輯訂單 -->
        <el-drawer ref="orderFormEdit" :class="{ 'only-close': activeOrder !== 'prepaidOrder' }"
          :visible.sync="editOrderVisible" :append-to-body="true"
          :size="$root.isSmallDevice ? '100%' : (activeOrder !== 'prepaidOrder' ? '90%' : '50%')" destroy-on-close
          :modal-append-to-body="false" :wrapper-closable="false" custom-class="order-drawer" @closed="componentKey++">
          <!-- header -->
          <PortalTarget slot="title" name="drawer-prepaid-header"></PortalTarget>
          <component :is="activeOrderComponent" :key="componentKey" :drawer-visible-detail="editOrderVisible"
            :default-value.sync="drawerOrderData" @store="onEditOrderDone" @update="onEditOrderDone">
          </component>
        </el-drawer>
        <!-- 退款 -->
        <el-dialog title="點數全數退款" :visible.sync="orderRefundShow" top="0" append-to-body>
          <el-form ref="refundForm" :rules="refundRules" :model="refundSubmitData"
            class="el-form--floating el-form-item--white-bg el-form-item--white-bg-border" label-position="top">
            <el-form-item label="退款金額計算方式" style="margin-bottom: 20px" prop="method"
              class="el-form-item--white-bg-border">
              <el-select v-model="refundSubmitData.method">
                <el-option v-if="!!depositInfo.solution1.canWithdrawTotal" label="以全部消費/儲值紀錄計算" :value="1"></el-option>
                <el-option v-if="!!depositInfo.solution2.canWithdrawTotal.point" label="以時間順序消費紀錄計算"
                  :value="2"></el-option>
              </el-select>
            </el-form-item>

            <template v-if="!!refundSubmitData.method">
              <template v-if="refundSubmitData.method === 1">
                <div :class="$style.table">
                  <div class="table__block" style="margin-bottom: 20px">
                    <div>
                      <div class="table__head">
                        <div class="table__title"> 項目 </div>
                        <div class="table__single"> 小計 </div>
                      </div>
                    </div>

                    <div class="table__box" style="margin-top: 10px">
                      <div class="table__row">
                        <div class="table__title"> 全部實際付款金額 </div>
                        <div class="table__single"> {{ solutionByTotal.allRealPayTotal }} </div>
                      </div>
                      <div class="table__row">
                        <div class="table__title"> 全部已消費點數 </div>
                        <div class="table__single"> - {{ solutionByTotal.allUseDepositTotal }} </div>
                      </div>
                      <div class="table__row">
                        <div class="table__title"> 小計 </div>
                        <div class="table__single"> {{ solutionByTotal.canWithdrawTotal }} </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h6>退款金額： {{ solutionByTotal.canWithdrawTotal }} 元</h6>
              </template>
              <template v-else>
                <div :class="$style.table">
                  <div class="table__block" style="margin-bottom: 20px">
                    <div>
                      <div class="table__head">
                        <div class="table__title"> 項目 </div>
                        <div class="table__single"> 儲值點數 </div>
                        <div class="table__single"> 額外贈點 </div>
                      </div>
                    </div>

                    <div class="table__box" style="margin-top: 10px">
                      <div class="table__row">
                        <div class="table__title"> 目前點數餘額 </div>
                        <div class="table__single"> {{ solutionByTime.reduceDepositTotal.point }} </div>
                        <div class="table__single"> {{ solutionByTime.reduceDepositTotal.bonus }} </div>
                      </div>
                      <div class="table__row">
                        <div class="table__title"> 全部已消費點數 </div>
                        <div class="table__single"> - {{ solutionByTime.allUseDepositTotal.point }} </div>
                        <div class="table__single"> - {{ solutionByTime.allUseDepositTotal.bonus }} </div>
                      </div>
                      <div class="table__row">
                        <div class="table__title"> 小計 </div>
                        <div class="table__single"> {{ solutionByTime.canWithdrawTotal.point }} </div>
                        <div class="table__single"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <h6>退款金額： {{ solutionByTime.canWithdrawTotal.point }} 元</h6>
              </template>
            </template>

            <el-form-item label="退款日期" prop="date">
              <el-date-picker v-model="refundSubmitData.date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="選擇日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="退款原因" style="margin-bottom: 20px" prop="reason" class="el-form-item--white-bg-border">
              <el-input v-model="refundSubmitData.reason" type="textarea" :autosize="{ minRows: 2 }"
                placeholder=""></el-input>
            </el-form-item>
            <p>提醒您：若有開立發票或收據，退款後請記得作廢或開立折讓單。</p>
            <el-form-item label="退款方式" style="margin-bottom: 20px" prop="paymentMethod"
              class="el-form-item--white-bg-border">
              <el-select v-model="refundSubmitData.paymentMethod">
                <el-option label="到店付款(現金)" value="Cash"> </el-option>
                <el-option label="線下匯款" value="Atm"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="bottom-btn-center">
            <el-button class="is-round" @click="closeOpenRefund">取消</el-button>
            <el-button class="is-round" type="primary" :loading="tryingRefund"
              @click="tryToRefund(defaultValue.id)">確認退款</el-button>
          </div>
        </el-dialog>
      </div>
    </template>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_sidebar.scss';

.tabs {
  :global {
    .el-radio-button:first-child .el-radio-button__inner {
      border-left: 0;
    }

    .el-radio-button .el-radio-button__inner {
      border-bottom: $color-border-base 1px solid;
    }
  }
}

.intro {
  margin-top: 30px;
  text-align: center;
}

.enabled {
  :global {
    .el-radio-button__orig-radio:disabled+.el-radio-button__inner {
      color: #121A30;
      cursor: pointer;

      &:hover {
        color: $color-primary;
      }
    }
  }
}

.btnTop {
  @include max-sm {
    >* {
      &:not(:first-child) {
        width: 50%;
      }
    }
  }
}

.wrapper {
  height: calc(100% - 128px);
  // margin-bottom: 80px;
  position: relative;
}

.table {

  // padding: 20px 30px 0;
  // height: calc(100% - 128px);
  &:global {
    &.isOutSide {
      // height: calc(100% - 90px);
    }
  }

  // overflow: auto;
  :global {
    .table {
      &__head {
        background-color: #e5e7eb;
        display: flex;
        padding: 10px;
        justify-content: space-between;
        margin-bottom: 10px;

        &.isEdit {
          background-color: #fff;
          margin-bottom: 0;
        }
      }

      &__box {
        background-color: #fff;
        // margin-bottom: 10px;
      }

      &__row {
        background-color: $color-body-bg;
        display: flex;
        padding: 10px;
        justify-content: space-between;

        &:not(:last-child) {
          border-bottom: $color-border-base 1px solid;
        }
      }

      &__title {
        width: 30%;
        flex-shrink: 0;
      }

      &__item {
        width: 20%;
        text-align: right;
      }

      &__single {
        text-align: right;
        width: 60%;
      }

      &__button {
        width: 10%;
        text-align: right;
        color: $color-state-info;
        cursor: pointer;
      }

      &__scroll {
        max-height: calc(100vh - 480px);

        &.isOutSide {
          // max-height: calc(100vh - 550px);
          // height: calc(100% - 90px);
        }

        overflow: auto;
      }
    }
  }
}
</style>
